module.exports = __webpack_public_path__ + "img/coming-soon.669a260f.png";